import React from 'react';
import { YStack, XStack, YStackProps, XStackProps, useMedia } from 'tamagui';

import { DSSpacing, DSRadius } from '../types';

interface CobuCardProps extends YStackProps {
  padding?: DSSpacing;
  borderRadius?: DSRadius;
  bordered?: boolean;
  layout?: 'vertical' | 'horizontal';
  responsive?: boolean;
  breakpoint?: 'sm' | 'md' | 'lg';
}

const CobuCard: React.FC<CobuCardProps> = ({
  padding = '$4',
  borderRadius = '$3',
  bordered = false,
  layout = 'vertical',
  children,
  bc = '$backgroundSecondary',
  boc = '$borderColor',
  ...props
}) => {
  
  const commonProps = {
    bc,
    boc: bordered ? boc : undefined,
    bw: bordered ? 1 : 0,
    br: borderRadius,
    p: padding,
    ...props
  };
  
  if (layout === 'horizontal') {
    return (
      <XStack {...(commonProps as XStackProps)}>
        {children}
      </XStack>
    );
  }

  return (
    <YStack {...commonProps}>
      {children}
    </YStack>
  );
};

export default CobuCard; 